(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6039],{

/***/ 46039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(186);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15072);
/* harmony import */ var src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84920);
/* harmony import */ var src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34892);
/* harmony import */ var src_utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39334);
/* harmony import */ var src_utils_services__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73113);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .kawebook {\n    padding-top: 15px;\n\n    strong {\n      font-family: 'DBHelvethaica', sans-serif;\n      font-size: 16pt;\n      font-weight: 500;\n      color: var(--secondary-color);\n      padding: 5px;\n      &:hover {\n        opacity: 0.7;\n      }\n    }\n\n    span {\n      font-family: 'Sarabun', sans-serif;\n      font-size: 14px;\n      font-weight: normal;\n      color: var(--secondary-color);\n      font-style: italic;\n    }\n  }\n  .footer-wrapper {\n    background-color: var(--black-color);\n    padding: 20px 0;\n    width: 100%;\n    height: 100%;\n    .grid-wrapper {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      grid-gap: 0px;\n\n      .block-1,\n      .block-2,\n      .block-3 {\n        padding: 0 20px;\n      }\n      .block-2 {\n        border-left: var(--border-default);\n        border-right: var(--border-default);\n        border-color: rgba(172, 172, 172, 0.3);\n        @media (max-width: 767px) {\n          border: none;\n        }\n      }\n      @media (max-width: 769px) {\n        .block-1,\n        .block-2,\n        .block-3 {\n          padding: 10px;\n        }\n      }\n      @media (max-width: 767px) {\n        grid-template-columns: 1fr;\n        .block-1,\n        .block-2,\n        .block-3 {\n          padding: 10px;\n        }\n      }\n    }\n\n    .footer-title {\n      font-size: 20pt;\n      font-weight: 400;\n      position: relative;\n      margin: 0 0 10px;\n      text-transform: uppercase;\n      color: #f8f8f8;\n      padding-top: 8px;\n    }\n\n    .footer-sale {\n      p {\n        font-weight: 200;\n        font-size: 16pt;\n        line-height: 1.15;\n        color: var(--secondary-color);\n        strong {\n          color: #f8f8f8;\n          font-size: 16pt;\n          font-weight: 400;\n        }\n      }\n    }\n\n    .footer-category {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      a {\n        cursor: pointer;\n        text-decoration: none;\n        color: var(--secondary-color);\n        font-weight: 200;\n        font-size: 16pt;\n        line-height: 1.15;\n        padding: 5px;\n        &:hover {\n          opacity: 0.7;\n        }\n      }\n      @media (max-width: 769px) {\n        grid-template-columns: repeat(2, 1fr);\n      }\n    }\n\n    /* Reserve space for async-fetched footer content so it fills in without shifting (CLS).\n     Sized from real data: categories = 13 + policy link (~31px/row), partners = 9.\n     Tune these in DevTools if item counts change. */\n    .block-2 .footer-category {\n      min-height: 250px; /* reserve enough so kawebook + sonp below don't shift when categories load */\n    }\n    .block-3 .footer-category {\n      min-height: 95px; /* 9 items / 3 cols = 3 rows */\n    }\n    @media (max-width: 767px) {\n      .block-1 {\n        min-height: 170px; /* title + contact block (dangerouslySetInnerHTML) */\n      }\n      .block-2 .footer-category {\n        min-height: 220px; /* 14 items / 2 cols = 7 rows */\n      }\n      .block-3 .footer-category {\n        min-height: 160px; /* 9 items / 2 cols = 5 rows */\n      }\n    }\n\n    .sonp {\n      text-align: center;\n      padding-top: 40px;\n    }\n    /* CSS-driven visibility replaces useResponsive (isMobile breakpoint = 690px) to avoid layout-shift on hydration */\n    .sonp-desktop {\n      display: block;\n    }\n    .sonp-mobile {\n      display: none;\n    }\n    @media (max-width: 690px) {\n      .sonp-desktop {\n        display: none;\n      }\n      .sonp-mobile {\n        display: block;\n      }\n    }\n  }\n  .copyright {\n    background: var(--secondary-color);\n    position: relative;\n    z-index: 1;\n    span {\n      color: var(--black-color);\n      font-size: 16pt;\n      font-weight: 400;\n      padding: 5px 0;\n      display: block;\n      text-align: center;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var DynamicAds = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84920)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84920)
            ];
        }
    },
    ssr: false
});
var Footer = function(param) {
    var data = param.data, ads = param.ads;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(null), salesData = ref[0], setSalesData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)([]), partnersData = ref1[0], setPartnersData = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
        var footer, company, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,src_utils_services__WEBPACK_IMPORTED_MODULE_10__/* .GET */ .H)("/api/footer")
                    ];
                case 1:
                    footer = _state.sent();
                    return [
                        4,
                        (0,src_utils_services__WEBPACK_IMPORTED_MODULE_10__/* .GET */ .H)("/api/v1.0/navigations/company-group")
                    ];
                case 2:
                    company = _state.sent();
                    if (!lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(footer)) setSalesData(footer);
                    if (!lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(company)) setPartnersData(company);
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error("".concat((0,src_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .timestamp */ .AB)(), " ==========> FOOTER ERROR : "), err.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            router.pathname === "/[cid]" && !lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_7__.KEY_ADS_POSITION.AD1X1,
                data: ads
            }),
            router.pathname === "/[cid]/[id]" && !lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(ads) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicAds, {
                position: src_utils_ads_dynamic_ads__WEBPACK_IMPORTED_MODULE_7__.KEY_ADS_POSITION.AD1X1,
                data: ads
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FooterWrapper, {
                id: "footer",
                style: {
                    filter: src_constants__WEBPACK_IMPORTED_MODULE_6__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(1)" : "unset"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                        className: "footer-wrapper",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "grid-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "block-1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                                className: "footer-title",
                                                children: "ติดต่อกรุงเทพธุรกิจ"
                                            }),
                                            !lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(salesData) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "footer-sale",
                                                dangerouslySetInnerHTML: {
                                                    __html: salesData
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "block-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                                className: "footer-title",
                                                children: "หมวดหมู่ข่าว"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "footer-category",
                                                children: [
                                                    !lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(data) && data.map(function(item, index) {
                                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            className: "item-category",
                                                            href: "/".concat(item.link),
                                                            //! DATALAYER
                                                            onClick: function() {
                                                                return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)({
                                                                    type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                                    router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                    section: "footer",
                                                                    position: "on:footer",
                                                                    data: {
                                                                        block: "2",
                                                                        title: item === null || item === void 0 ? void 0 : item.nameTh,
                                                                        heading: "หมวดหมู่ข่าว"
                                                                    }
                                                                });
                                                            },
                                                            children: item.nameTh
                                                        }, index);
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        className: "item-policy",
                                                        href: "/privacy-policy",
                                                        //! DATALAYER
                                                        onClick: function() {
                                                            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)({
                                                                type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                section: "footer",
                                                                position: "on:footer",
                                                                data: {
                                                                    block: "2",
                                                                    title: "นโยบายการเป็นส่วนตัว",
                                                                    heading: "หมวดหมู่ข่าว"
                                                                }
                                                            });
                                                        },
                                                        children: "นโยบายการเป็นส่วนตัว"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: "kawebook",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        href: src_constants__WEBPACK_IMPORTED_MODULE_6__/* .NEXT_PUBLIC_SHOW_LINK_SPECIAL */ .gX !== null && src_constants__WEBPACK_IMPORTED_MODULE_6__/* .NEXT_PUBLIC_SHOW_LINK_SPECIAL */ .gX !== void 0 ? src_constants__WEBPACK_IMPORTED_MODULE_6__/* .NEXT_PUBLIC_SHOW_LINK_SPECIAL */ .gX : "https://www.kawebook.com",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer follow",
                                                        //! DATALAYER
                                                        onClick: function() {
                                                            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)({
                                                                type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                section: "footer",
                                                                position: "on:footer",
                                                                data: {
                                                                    block: "2",
                                                                    title: "นิยาย by Kawebook",
                                                                    heading: "พาร์ทเนอร์"
                                                                }
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                            children: " นิยาย "
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        children: " by KaweBook "
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "sonp sonp-desktop",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    href: "https://www.facebook.com/SONPThai/",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer nofollow",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                        src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_6__/* .APP_IMG */ .T, "/logo_sonp.png"),
                                                        alt: "sonp",
                                                        width: "210",
                                                        height: "70"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "block-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                                className: "footer-title",
                                                children: "พาร์ทเนอร์"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "footer-category",
                                                children: partnersData.map(function(item, index) {
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        className: "item-partner",
                                                        href: item.link,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        //! DATALAYER
                                                        onClick: function() {
                                                            return (0,src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .sendDataLayerGlobal */ .dE)({
                                                                type: src_utils_datalayer_send_datalayer__WEBPACK_IMPORTED_MODULE_8__/* .DATALAYER_TYPE.TRACK_POSITION */ .$7.TRACK_POSITION,
                                                                router: router === null || router === void 0 ? void 0 : router.pathname,
                                                                section: "footer",
                                                                position: "on:footer",
                                                                data: {
                                                                    block: "3",
                                                                    title: item === null || item === void 0 ? void 0 : item.name,
                                                                    heading: "พาร์ทเนอร์"
                                                                }
                                                            });
                                                        },
                                                        children: item.name
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "sonp sonp-mobile",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    href: "https://www.facebook.com/SONPThai/",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer nofollow",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                        src: "".concat(src_constants__WEBPACK_IMPORTED_MODULE_6__/* .APP_IMG */ .T, "/logo_sonp.png"),
                                                        alt: "sonp",
                                                        width: "210",
                                                        height: "70"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "copyright",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                children: [
                                    " \xa9 ",
                                    "".concat(new Date().getFullYear()),
                                    " กรุงเทพธุรกิจ มีเดีย จำกัด. All Rights Reserved."
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "truehit",
                                id: "truehits_div"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);
var FooterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].footer(_templateObject());


/***/ }),

/***/ 84920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ads": function() { return /* binding */ Ads; },
/* harmony export */   "KEY_ADS_PAGE": function() { return /* binding */ KEY_ADS_PAGE; },
/* harmony export */   "KEY_ADS_POSITION": function() { return /* binding */ KEY_ADS_POSITION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15072);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 2147483647;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #4142429c;\n\n  &.close {\n    display: none;\n  }\n  .light-box {\n    position: relative;\n    &::before {\n      content: 'X';\n      cursor: pointer;\n      position: absolute;\n      top: -24px;\n      right: 0;\n      color: rgba(0, 0, 0, 0.788);\n      background-color: #fafafab7;\n      border-top-right-radius: 3px;\n      border-top-left-radius: 3px;\n      padding: 2px 7px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &.ads-billboard {\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgb(245, 245, 245);\n    /* margin: 30px auto; */\n    min-height: 300px;\n    iframe {\n      margin: auto;\n    }\n    @media (max-width: 475px) {\n      min-height: 330px;\n    }\n  }\n  &.ads-ad1x1 {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n  }\n  &.ads-sticky-1,\n  &.ads-sticky-2,\n  &.ads-sticky-3 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n    margin-bottom: 15px;\n    min-height: 300px;\n    background: rgb(245, 245, 245);\n    padding: 15px;\n  }\n  &.ads-postarticle {\n    position: sticky;\n    bottom: 0;\n    z-index: 50;\n    display: flex;\n    justify-content: center;\n    overflow: hidden;\n    min-height: 90px;\n  }\n\n  &.ads-inarticle-1,\n  &.ads-inarticle-2,\n  &.ads-inarticle-3 {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    margin: 5px auto;\n    overflow: hidden;\n    min-height: 90px;\n    background: rgb(245, 245, 245);\n    padding: 15px 0px;\n    img,\n    iframe {\n      max-width: 100%;\n      display: block;\n      margin: auto;\n    }\n  }\n  &.ads-election-1,\n  &.ads-election-2,\n  &.ads-election-3,\n  &.ads-election-4,\n  &.ads-election-5,\n  &.ads-election-6,\n  &.ads-election-7 {\n    margin: 15px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .mobile {\n    display: none;\n    @media (max-width: 1024px) {\n      display: block;\n    }\n  }\n  .desktop {\n    display: block;\n    @media (max-width: 1025px) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






// ? TODO:  <DynamicAds position={KEY_ADS_POSITION.BILLBOARD} page={KEY_ADS_PAGE.CONTENT} />
/* -------------------------------- KEY_TYPE -------------------------------- */ var KEY_ADS_POSITION = {
    BILLBOARD: "billboard",
    STICKY_1: "sticky-1",
    STICKY_2: "sticky-2",
    STICKY_3: "sticky-3",
    INARTICLE_1: "inarticle-1",
    INARTICLE_2: "inarticle-2",
    INARTICLE_3: "inarticle-3",
    POSTARTICLE: "postarticle",
    AD1X1: "ad1x1",
    LIGHTBOX: "light-box",
    ELECTION_1: "election-1",
    ELECTION_2: "election-2",
    ELECTION_3: "election-3",
    ELECTION_4: "election-4",
    ELECTION_5: "election-5",
    ELECTION_6: "election-6",
    ELECTION_7: "election-7",
    RECTANGLE_A: "rectangle-a",
    RECTANGLE_B: "rectangle-b",
    RECTANGLE_C: "rectangle-c"
};
var KEY_ADS_PAGE = {
    HOMEPAGE: "homepage",
    CATEGORY: "category",
    CONTENT: "content",
    TAG: "tag",
    SEARCH: "search"
};
var Ads = function(param) {
    var _adsBox = param.adsBox, adsBox = _adsBox === void 0 ? false : _adsBox, _slotId = param.slotId, slotId = _slotId === void 0 ? "" : _slotId, _slotSize = param.slotSize, slotSize = _slotSize === void 0 ? [] : _slotSize, _slotDefine = param.slotDefine, slotDefine = _slotDefine === void 0 ? "" : _slotDefine, _className = param.className, className = _className === void 0 ? "" : _className, position = param.position, _handler = param.handler, handler = _handler === void 0 ? function() {} : _handler;
    if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(slotId) || lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(slotDefine) || lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(slotSize)) return null;
    // const isDesktop = useDesktop();
    // const slotSize = isDesktop ? sizeDesktop : !_.isEmpty(sizeMobile) && sizeMobile;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        window.googletag.cmd.push(function() {
            window.googletag.defineSlot(slotDefine, slotSize, slotId).addService(window.googletag.pubads()).setCollapseEmptyDiv(true, true);
            window.googletag.pubads().enableSingleRequest();
            window.googletag.enableServices();
            window.googletag.cmd.push(function() {
                window.googletag.display(slotId);
            });
        });
    }, []);
    // console.log('position', position);
    // console.log('slotId', slotId);
    switch(position){
        case "light-box":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsLightBox, {
                    id: "ads-nlightbox",
                    className: "light-box-ads ".concat(!adsBox ? "close" : "open"),
                    style: {
                        filter: src_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0)" : ""
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "light-box",
                        onClick: handler,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsWrapper, {
                            className: className,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                id: slotId
                            })
                        })
                    })
                })
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AdsWrapper, {
                className: className,
                style: {
                    filter: src_constants__WEBPACK_IMPORTED_MODULE_4__/* .SHOW_COMMEMORATE */ .WT === "true" ? "grayscale(0)" : "unset"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    id: slotId
                })
            });
    }
};
var AdsLightBox = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject());
var AdsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject1());
var DynamicAds = function(param) {
    var _adsBox = param.adsBox, adsBox = _adsBox === void 0 ? false : _adsBox, _position = param.position, position = _position === void 0 ? "" : _position, _data = param.data, data = _data === void 0 ? [] : _data, _handler = param.handler, handler = _handler === void 0 ? function() {} : _handler;
    var isMb = (0,react_responsive__WEBPACK_IMPORTED_MODULE_6__.useMediaQuery)({
        query: "(max-width: 1023px)"
    });
    var isDt = (0,react_responsive__WEBPACK_IMPORTED_MODULE_6__.useMediaQuery)({
        query: "(min-width: 1024px)"
    });
    var _adsArray = !lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(data) ? data : [];
    // เช็คตำแหน่ง ADS
    var _adsSlot = _adsArray.find(function(_data) {
        return (_data === null || _data === void 0 ? void 0 : _data.position) === position;
    });
    if (position === KEY_ADS_POSITION.POSTARTICLE) {
        // console.log(position, `ads-${position}`);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SlotWrapper, {
            className: "ads-sticky-overflow",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "mobile",
                    children: !isDt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeMobile,
                        position: position
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "desktop",
                    children: !isMb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeDesktop,
                        position: position
                    })
                })
            ]
        });
    }
    if (!lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(_adsSlot)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SlotWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "mobile",
                    children: !isDt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeMobile,
                        position: position
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "desktop",
                    children: !isMb && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Ads, {
                        adsBox: adsBox,
                        handler: handler,
                        className: "ads-".concat(position),
                        slotDefine: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotDefine,
                        slotId: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.slotId,
                        slotSize: _adsSlot === null || _adsSlot === void 0 ? void 0 : _adsSlot.sizeDesktop,
                        position: position
                    })
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["default"] = (DynamicAds);
// :: Default ::
// <Ads
//    className='ads'
//    slotDefine='/231599934,12270527/springnews/homepage/billboard'
//    slotId='div-gpt-ad-1622722566999-0'
//    slotSize=[[300, 250], [336, 280]] />
var SlotWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject2());


/***/ }),

/***/ 73113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ GET; },
/* harmony export */   "M": function() { return /* binding */ GET_ARTICLES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15072);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39334);






// Service : GET ------------------------- */
function GET() {
    return _GET.apply(this, arguments);
}
function _GET() {
    _GET = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    // If don't have data return [];
                    // If have data return [{ id: 1 }] or { data: [] }
                    // If can't call api return { data: null, msg: null }
                    // console.log(timestamp(), _url, ':');
                    if (!data.msg) {
                        if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data.data)) {
                            return [
                                2,
                                all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data.data
                            ];
                        }
                        return [
                            2,
                            data
                        ];
                    }
                    return [
                        2,
                        []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat((0,_helper__WEBPACK_IMPORTED_MODULE_2__/* .timestamp */ .AB)(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET.apply(this, arguments);
}
function GET_ARTICLES() {
    return _GET_ARTICLES.apply(this, arguments);
}
function _GET_ARTICLES() {
    _GET_ARTICLES = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var url, external, all, _url, response, _tmp, data, _tmp1, _tmp2, err;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "", external = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false, all = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _url = external ? "".concat(url) : "".concat(src_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_URI */ .G9).concat(url);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = {};
                    return [
                        4,
                        fetch(_url, (_tmp.method = "GET", _tmp.headers = {
                            "Content-Type": "text/plain" // Solved issues call OPTIONS
                        }, _tmp))
                    ];
                case 2:
                    response = _state.sent();
                    if (!response.ok) {
                        throw new TypeError("Network response was not OK");
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    data = _state.sent();
                    _tmp1 = {};
                    if ((data === null || data === void 0 ? void 0 : data.statusCode) === 404) {
                        return [
                            2,
                            data
                        ];
                    } else if (!lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(data === null || data === void 0 ? void 0 : data.data)) {
                        return [
                            2,
                            all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp1, data) : data === null || data === void 0 ? void 0 : data.data
                        ];
                    }
                    _tmp2 = {};
                    return [
                        2,
                        all ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_tmp2, data) : []
                    ];
                case 4:
                    err = _state.sent();
                    console.log("".concat(new Date().toUTCString(), " ===========> GET ERROR : ").concat(_url));
                    console.log("".concat(err));
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _GET_ARTICLES.apply(this, arguments);
}


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ })

}]);